import './css/style.css';

document.addEventListener('DOMContentLoaded', () => {

});
